module.exports = __webpack_public_path__ + "img/1.0b790d18.jpg";